module.exports = __webpack_public_path__ + "media/images/talent/circle-button-151f5344209cb971ab6376ae7a87f998.png";